import { render, staticRenderFns } from "./Virus.vue?vue&type=template&id=72987628&scoped=true"
import script from "./Virus.vue?vue&type=script&lang=js"
export * from "./Virus.vue?vue&type=script&lang=js"
import style0 from "./Virus.vue?vue&type=style&index=0&id=72987628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72987628",
  null
  
)

export default component.exports